import ModuleLayout from './ModuleLayout';

export * from './ModuleLayout';
export default ModuleLayout;
